import styled from "styled-components";

interface TableContainerProps {
  height?: string;
}

export const TableContainer = styled.div<TableContainerProps>`
  display: block;
  overflow: auto;
  width: 100%;
  height: ${(props) => props.height || "100%"};

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1; /* Background color of the scrollbar track */
    border: 2px solid #ccc;    /* Border around the scrollbar track */
    margin-bottom: 3px;
    margin-top: 2px;
}

/* Target the scrollbar itself */
::-webkit-scrollbar {
    width: 5px;               /* Width of the scrollbar */
}

  thead th {
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    top: 0;
    z-index: 2;
    height: 30px;
    vertical-align: middle;
    font-size: 0.9rem;
  }

  tbody td {
    vertical-align: middle;
    font-size: 1rem;
    height: 20px;
    padding: 0.5rem;
  }
`;
